import React from "react";
import { businesses } from "../../assets/images/icons";
import { Slot } from "../../lib/types";

interface IProps {
  slotChain: any,
  active: boolean | null
}

const tops = [0, 15, 35, 55, 70];
const rights = [25, 15, 10, 15, 25];
const industries = {
  24: "baker",
  25: "mason",
  26: "smith",
  27: "trader",
  28: "alchemist"
};

const CityPart = (props: IProps) => {
  const slot: Slot = props.slotChain.slots
    ? props.slotChain.slots[Object.keys(props.slotChain.slots)
      .find(k => !Number.isNaN(Number.parseInt(k, 10))) || ""]
    : props.slotChain[Object.keys(props.slotChain)
      .find(k => !Number.isNaN(Number.parseInt(k, 10))) || ""][Object
      .keys(props.slotChain[Object.keys(props.slotChain)
        .find(k => !Number.isNaN(Number.parseInt(k, 10))) || ""] || {})
      .find(k => !Number.isNaN(Number.parseInt(k, 10))) || ""];

  return (<div className={`city-part ${props.active ? "active" : ""}`} id={props.slotChain.representantName}>
    {props.slotChain.representantName?.includes("workshop-")
      ? Object.keys(props.slotChain).filter(k => !Number.isNaN(Number.parseInt(k, 10)))
        .map((key, index) => {
          const workshop = props.slotChain[key][Object.keys(props.slotChain[key])
            .find(k => !Number.isNaN((Number.parseInt(k, 10)))) || ""];

          return (<span
            className={`label ${props.slotChain[key].plus ? "plus" : ""} ${props.slotChain[key].minus ? "minus" : ""}`}
            style={{ top: `${tops[index]}%`, right: `${rights[index]}%` }}
          >
            {workshop.pops < workshop.activeType.popPossible
            && <span className={"pop-badge"}><i className={"icon icon-pop icon-xs-badge middle"}/></span>}
            <img
              // @ts-ignore
              src={businesses[industries[key]]} alt={industries[key]}
              style={{
                display: "flex",
                position: "absolute",
                top: "20%",
                right: "80%"
              }}
            />
            {workshop.type.level}
            {props.slotChain[key].plus && !!(workshop.turnsToBuilt
              || workshop.turnsToUpgrade) && <span
              className={"positive"}
              style={{
                display: "inline-block",
                position: "absolute",
                fontSize: "10px",
                width: "max-content",
                top: "-18px",
                right: "-56px"
              }}
            >{workshop.turnsToBuilt
            || workshop.turnsToUpgrade} turns</span>}
            {props.slotChain[key].minus && !!workshop.turnsToRepair && <span
              className={"negative"}
              style={{
                display: "inline-block",
                position: "absolute",
                fontSize: "10px",
                width: "max-content",
                top: "-5px",
                right: "-60px"
              }}
            >{workshop.turnsToRepair} turns</span>}
            {workshop.inDemolition && <span
              className={"negative"}
              style={{
                display: "inline-block",
                position: "absolute",
                fontSize: "10px",
                width: "max-content",
                top: "-5px",
                right: "-55px"
              }}
            ><i className={"icon icon-sm icon-zbourat middle"}/> 1 turn</span>}
          </span>)
        })
      : <span className={`label ${props.slotChain.plus ? "plus" : ""} ${props.slotChain.minus ? "minus" : ""}`}>
        {slot.pops < slot.activeType.popPossible
        && <span className={"pop-badge"}><i className={"icon icon-pop icon-xs-badge middle"}/></span>}
        {slot?.type.level || 0}
        {props.slotChain.plus && !!(slot.turnsToBuilt || slot.turnsToUpgrade) && <span
          className={"positive"}
          style={{
            display: "inline-block",
            position: "absolute",
            fontSize: "10px",
            width: "max-content",
            top: "-18px",
            right: "-56px"
          }}
        >{slot.turnsToBuilt || slot.turnsToUpgrade} turns</span>}
        {props.slotChain.minus && !!slot.turnsToRepair && <span
          className={"negative"}
          style={{
            display: "inline-block",
            position: "absolute",
            fontSize: "10px",
            width: "max-content",
            top: "-5px",
            right: "-60px"
          }}
        >{slot.turnsToRepair} turns</span>}
        {slot.inDemolition && <span
          className={"negative"}
          style={{
            display: "inline-block",
            position: "absolute",
            fontSize: "10px",
            width: "max-content",
            top: "-5px",
            right: "-55px"
          }}
        ><i className={"icon icon-sm icon-zbourat middle"}/> 1 turn</span>}
    </span>}
  </div>)
};

export default CityPart;
